import React from "react";
import PersonnelInfoTable from "./PersonnelInfoTable";

const PersonnelSection = ({transRoutes, sectionName, showCompletedInfo, 
  showGroupInfo, allowForceEdit, showFilter,
   driverName, vehicle, relatedOutbound, 
   vehicles, isInbound, deleteFile, keyword,
   statusFilter, customerTypeFilter, customerNameFilter, customerTableId, routeTypeFilter,
  onRouteUpdated = null,
  hideDischargedMembers = false,
  dischargedCustomerIds = null,
  hideEmptyRouteTypeRows = false,
  showInboundParticipantsReportButton = true,
  groupActionsPortalTarget = null,
  groupActionsUsePortal = false,
  }) => {
  return (
    <>
      {/* <div className="text-primary mb-4"><h5>{sectionName}</h5></div> */}
      <div className="list row">
        <div className="col-md-12">
          <PersonnelInfoTable transRoutes={transRoutes} relatedOutbound={relatedOutbound}
            showCompletedInfo={showCompletedInfo} allowForceEdit={allowForceEdit} 
            isInbound={isInbound} showFilter={showFilter} 
            showGroupInfo={showGroupInfo} driverName={driverName} 
            vehicle={vehicle} vehicles={vehicles} deleteFile={deleteFile}
            statusFilter={statusFilter} customerTypeFilter={customerTypeFilter}
            customerNameFilter={customerNameFilter}
            customerTableId={customerTableId}
            routeTypeFilter={routeTypeFilter}
            hideDischargedMembers={hideDischargedMembers}
            dischargedCustomerIds={dischargedCustomerIds}
            hideEmptyRouteTypeRows={hideEmptyRouteTypeRows}
            onRouteUpdated={onRouteUpdated}
            showInboundParticipantsReportButton={showInboundParticipantsReportButton}
            groupActionsPortalTarget={groupActionsPortalTarget}
            groupActionsUsePortal={groupActionsUsePortal}
          />
        </div>
      </div>
    </>
    
  );
};

export default PersonnelSection;